// App.tsx
import { useState } from "react";
import Quiz from "./games/Quiz";
import Memory from "./games/Memory";
import STCMJSC from "./games/STCMJSC";
import MenteurMenteur from "./games/MenteurMenteur";
import SoloDetective from "./games/SoloDetective";

import quizLogo from "./assets/logo-quiz.png";
import memoryLogo from "./assets/logo-memory.png";
import stcmjscLogo from "./assets/logo-stcmjsc.png";
import menteurLogo from "./assets/logo-menteur.png";
import detectiveLogo from "./assets/logo-detective.png";

import "./App.css";

export default function App() {
  const [selectedGame, setSelectedGame] = useState<
    "quiz" | "memory" | "stcmjsc" | "menteur" | "enquete" | null
  >(null);

  if (!selectedGame) {
    return (
      <div className="home-background">
        <div className="main-container">
          <h1 className="title">🎮 Games GPT</h1>
          <div className="game-grid">
            <div className="game-card" onClick={() => setSelectedGame("quiz")}>
              <img src={quizLogo} className="game-icon" alt="quiz" />
              <div>
                <div className="game-title">Quiz</div>
                <div className="game-subtitle">“Tu te mets combien ?”</div>
              </div>
            </div>

            <div className="game-card" onClick={() => setSelectedGame("memory")}>
              <img src={memoryLogo} className="game-icon" alt="memory" />
              <div>
                <div className="game-title">Memory</div>
                <div className="game-subtitle">ChatGPT Edition</div>
              </div>
            </div>

            <div className="game-card" onClick={() => setSelectedGame("stcmjsc")}>
              <img src={stcmjscLogo} className="game-icon" alt="stcmjsc" />
              <div>
                <div className="game-title">STCMJSC</div>
                <div className="game-subtitle">Si t’es chaud moi je suis chaud</div>
              </div>
            </div>

            <div className="game-card" onClick={() => setSelectedGame("menteur")}>
              <img src={menteurLogo} className="game-icon" alt="menteur" />
              <div>
                <div className="game-title">Menteur Menteur</div>
                <div className="game-subtitle">Une vérité, plein de mensonges</div>
              </div>
            </div>

            <div className="game-card" onClick={() => setSelectedGame("enquete")}>
              <img src={detectiveLogo} className="game-icon" alt="enquete" />
              <div>
                <div className="game-title">Enquête Solo</div>
                <div className="game-subtitle">Explore, interroge, déduis</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }

  return selectedGame === "quiz" ? (
    <Quiz onQuit={() => setSelectedGame(null)} />
  ) : selectedGame === "memory" ? (
    <Memory onQuit={() => setSelectedGame(null)} />
  ) : selectedGame === "stcmjsc" ? (
    <STCMJSC onQuit={() => setSelectedGame(null)} />
  ) : selectedGame === "menteur" ? (
    <MenteurMenteur onQuit={() => setSelectedGame(null)} />
  ) : (
    <SoloDetective onQuit={() => setSelectedGame(null)} />
  );
}
